import * as React from 'react'
import Button from '@mulesoft/anypoint-components/lib/Button'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'

export type PillButtonContent = {
  label: string,
  iconName?: string,
}

export type PillButtonProps = {
  content: PillButtonContent,
  selected: string,
  hideIcon: boolean,
  disableAll: boolean,
  onClick: (type: string) => void
}

export default class PillButton extends React.PureComponent<PillButtonProps> {
  constructor(props: PillButtonProps) {
    super(props)
  }
  
  buttonOnClick() {
    const {content, onClick} = this.props
    const type = content.label.toLowerCase().replace(' ', '-')
    const hash = window.location.hash
    
    window.location.hash = `${hash.substring(0, hash.lastIndexOf('/'))}/${type}`
    onClick(type)
  }
  
  render() {
    const {content, selected, disableAll, hideIcon} = this.props
    const type = content.label.toLowerCase().replace(' ', '-')
    
    return (
      <Button
        kind={'primary'}
        ref={type}
        key={type}
        noFill={true}
        testId={`test-${type}`}
        onClick={this.buttonOnClick.bind(this, type)}
        disabled={disableAll}
        className={(selected === type) ? 'pill-menu-button selected-button' : 'pill-menu-button'}
      >
        {!hideIcon && content.iconName && <IconPanel name={content.iconName} size={16}/>}
        {content.label}
      </Button>
    )
  }
}
